// Based on the textarea-caret-position library
// https://github.com/component/textarea-caret-position

import { cloneDeep } from "lodash-es"

const DEFAULT_RESULT = { left: 0, top: 0 }

const PROPERTIES_AFFECTING_OFFSET = [
  "direction",
  "boxSizing",
  "width",
  "height",
  "overflowX",
  "overflowY",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderStyle",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "fontStretch",
  "fontSize",
  "fontSizeAdjust",
  "lineHeight",
  "fontFamily",
  "textAlign",
  "textTransform",
  "textIndent",
  "textDecoration",
  "letterSpacing",
  "wordSpacing",
  "tabSize",
  "MozTabSize",
]

const applyStylesToMirrorTextarea = (mirrorElement, textarea) => {
  mirrorElement.style.visibility = "hidden"
  mirrorElement.style.whiteSpace = "pre-wrap"
  mirrorElement.style.wordWrap = "break-word"
  mirrorElement.style.position = "absolute"

  const textareaStyle = window.getComputedStyle ? window.getComputedStyle(textarea) : textarea.currentStyle

  PROPERTIES_AFFECTING_OFFSET.forEach((property) => {
    mirrorElement.style[property] = textareaStyle[property]
  })

  if (window.mozInnerScreenX != null) { // Check if Firefox
    if (textarea.scrollHeight > parseInt(textareaStyle.height, 10)) mirrorElement.style.overflowY = "scroll"
  } else {
    mirrorElement.style.overflowY = "scroll"
  }
}

const useTextareaCaretOffset = (textareaRef) => {
  const result = cloneDeep(DEFAULT_RESULT)
  const textarea = textareaRef?.current

  if (!textarea) return result

  const caretPosition = textarea.selectionStart ?? 0
  const textBeforeCaret = textarea.value.substring(0, caretPosition)
  const textAfterCaret = textarea.value.substring(caretPosition) || "."

  const mirrorDiv = document.createElement("div")
  document.body.appendChild(mirrorDiv)
  applyStylesToMirrorTextarea(mirrorDiv, textarea)

  mirrorDiv.textContent = textBeforeCaret

  const afterCaretSpan = document.createElement("span")
  afterCaretSpan.textContent = textAfterCaret
  mirrorDiv.appendChild(afterCaretSpan)

  const scrollOffset = textarea.parentElement?.scrollTop ?? 0

  result.left = afterCaretSpan.offsetLeft
  result.top = afterCaretSpan.offsetTop - scrollOffset

  document.body.removeChild(mirrorDiv)

  return result
}

export default useTextareaCaretOffset
